<template lang="pug">
button.promos-header__controller(@click="handleClick")
  transition(name="fade")
    icon(:name="getIcon")
</template>

<script>
export default {
  name: "PromosHeaderController",
  props: {
    isOpened: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getIcon() {
      return this.isOpened ? "close" : "menu";
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/blocks/header-controller";
</style>